export function buildFileTree(files) {

  const root = { name: "root", children: {}, files: [] };

  files.forEach(file => {
    // 1. Obtener la llave. Soportamos 'key' (S3) o 'path' (Local)
    let originalKey = file.key || file.path;

    if (!originalKey) {
        return;
    }

    // 2. Limpieza robusta: Quitamos barra inicial si existe (ej: "/uploads/..." -> "uploads/...")
    if (originalKey.startsWith('/')) {
        originalKey = originalKey.substring(1);
    }

    const parts = originalKey.split("/");

    // 🛑 DEBUG: Descomenta esto si quieres ver cada archivo procesado
    // console.log("   📄 Procesando:", originalKey, "| Partes:", parts.length);

    // 3. VALIDACIÓN DE ESTRUCTURA
    // Esperamos: uploads / area / uuid / Evento / ...
    // Si es muy corto, lo ignoramos o lo mandamos a "Otros"
    if (parts.length < 4) {
        // Opción: Si quieres ver archivos sueltos, descomenta esto:
        // root.files.push({ ...file, name: originalKey, fullKey: originalKey });
        return;
    }

    // 4. CORTE INTELIGENTE (Slice)
    // Eliminamos las carpetas de sistema.
    // uploads (0) -> marketing (1) -> uuid (2) -> EMPIEZA CONTENIDO (3)
    const meaningfulParts = parts.slice(3);

    let currentNode = root;

    meaningfulParts.forEach((part, index) => {
      const isFile = index === meaningfulParts.length - 1;

      // Limpieza visual: "Corona_Capital" -> "Corona Capital"
      const cleanName = part.replace(/_/g, " ");

      if (isFile) {
        // 5. EXTRACTOR DE NOMBRE
        // El backend guarda: "uuid-largo_nombre-real.pdf"
        // Buscamos el primer guión bajo (_) y tomamos lo que sigue.
        const underscoreIndex = part.indexOf('_');

        let displayFileName = part;
        if (underscoreIndex !== -1) {
            displayFileName = part.substring(underscoreIndex + 1);
        }

        currentNode.files.push({
          ...file,
          name: displayFileName, // Nombre limpio para mostrar
          fullKey: originalKey,  // Llave real para S3
          key: originalKey       // Compatibilidad
        });
      } else {
        // 6. CONSTRUCCIÓN DE CARPETA
        if (!currentNode.children[cleanName]) {
          currentNode.children[cleanName] = {
            name: cleanName,
            children: {},
            files: []
          };
        }
        currentNode = currentNode.children[cleanName];
      }
    });
  });

  const totalFolders = Object.keys(root.children).length;

  if (totalFolders === 0 && files.length > 0) {
      console.error("❌ ALERTA: Hay archivos pero no se crearon carpetas. Revisa el .slice(3) o la estructura de la ruta.");
  }

  return root;
}
